import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "@phosphor-icons/react";
import { CITIES } from "@/data/cities";

export default function ServiceArea() {
  return (
    <section id="service-area" className="py-16 md:py-32 bg-primary grain" data-testid="service-area-section">
      <div className="max-w-6xl mx-auto px-6 md:px-10 relative z-10 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-300 mb-3">Service Areas</p>
          <h2 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-white">
            Serving Everett &amp; surrounding communities
          </h2>
          <p className="mt-4 text-white/70 text-lg">
            Proudly cleaning homes and businesses across Snohomish County and North King County. Select your city for local details.
          </p>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 gap-3">
            {CITIES.map((city, i) => (
              <motion.div
                key={city.slug}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.04 }}
              >
                <Link
                  to={`/${city.slug}`}
                  className="group flex flex-col rounded-xl border border-white/15 bg-white/5 px-4 py-3 hover:bg-white/10 hover:border-emerald-300/40 transition-colors h-full"
                  data-testid={`service-city-link-${city.slug}`}
                >
                  <span className="flex items-center gap-2 text-white/90 text-sm font-medium">
                    <MapPin size={16} weight="fill" className="text-emerald-300 shrink-0" />
                    {city.name}
                    <ArrowUpRight
                      size={14}
                      className="ml-auto text-emerald-300 opacity-0 -translate-x-1 translate-y-1 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-all duration-300"
                    />
                  </span>
                  <span className="mt-1 pl-6 text-xs text-white/50">{city.region}</span>
                </Link>
              </motion.div>
            ))}
          </div>
          <p className="mt-4 text-sm text-white/50">
            Also serving Marysville, Lake Stevens, Mountlake Terrace, Shoreline &amp; nearby communities.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rounded-3xl overflow-hidden border border-white/15 shadow-2xl h-[420px] bg-white/5"
        >
          {/* Placeholder embed — replace src with the official Explus Cleaning Google Business location later. */}
          <iframe
            title="Explus Cleaning service area — Everett, WA"
            src="https://maps.google.com/maps?q=Everett,%20Washington&z=11&output=embed"
            className="w-full h-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            data-testid="google-map"
          />
        </motion.div>
      </div>
    </section>
  );
}
